import { ActionCreator } from '@sendoutcards/core'
import { GiftVariationFragment } from 'src/graphql'

export const selectHighLevelCategory = ActionCreator(
  'SELECT_HIGH_LEVEL_CATEGORY',
  (categoryId: string) => ({ categoryId }),
)

export const selectGift = ActionCreator('SELECT_GIFT', (giftId: string) => ({
  giftId,
}))

export const selectChildCategory = ActionCreator(
  'SELECT_CHILD_CATEGORY',
  (categoryId: string) => ({
    categoryId,
  }),
)

export const deselectGift = ActionCreator('DESELECT_GIFT')

export const saveGift = ActionCreator(
  'SAVE_GIFT',
  (giftVariation: GiftVariationFragment) => ({
    giftVariation,
  }),
)

export const updateGift = ActionCreator(
  'UPDATE_GIFT',
  (giftVariation: GiftVariationFragment) => ({
    giftVariation,
  }),
)

export const selectGiftToView = ActionCreator(
  'SELECT_GIFT_TO_VIEW',
  (giftId: string) => ({ giftId }),
)

export const closeGiftBeingViewed = ActionCreator('CLOSE_GIFT_BEING_VIEWED')
